export type KnowledgeChunkType =
  | 'fact'
  | 'process'
  | 'scenario'
  | 'system'
  | 'strategy';

export type MechanicType =
  | 'recall'
  | 'sequence'
  | 'scenario'
  | 'simulation'
  | 'strategy';

export interface KnowledgeChunk {
  id: string;
  type: KnowledgeChunkType;
  title: string;
  body: string;
  sourceIndex: number;
}

export interface PlayableUnit {
  id: string;
  title: string;
  chunkIds: string[];
  mechanic: MechanicType;
  challenge: string;
  feedbackLoop: string;
}

export function chunkKnowledge(raw: string): KnowledgeChunk[] {
  const blocks = raw
    .split(/\n{2,}/)
    .map((x) => x.trim())
    .filter(Boolean);

  return blocks.map((body, idx) => {
    const lower = body.toLowerCase();
    const type: KnowledgeChunkType =
      lower.includes('שלב') || lower.includes('step')
        ? 'process'
        : lower.includes('if') || lower.includes('מקרה')
          ? 'scenario'
          : lower.includes('מערכת') || lower.includes('system')
            ? 'system'
            : lower.includes('אסטרטג') || lower.includes('strategy')
              ? 'strategy'
              : 'fact';

    return {
      id: `kc_${idx + 1}`,
      type,
      title: body.slice(0, 60),
      body,
      sourceIndex: idx,
    };
  });
}

export function selectMechanic(type: KnowledgeChunkType): MechanicType {
  if (type === 'process') return 'sequence';
  if (type === 'scenario') return 'scenario';
  if (type === 'system') return 'simulation';
  if (type === 'strategy') return 'strategy';
  return 'recall';
}

export function buildPlayableUnits(chunks: KnowledgeChunk[]): PlayableUnit[] {
  return chunks.map((chunk, idx) => {
    const mechanic = selectMechanic(chunk.type);
    return {
      id: `pu_${idx + 1}`,
      title: `${chunk.title.slice(0, 36)} • mission`,
      chunkIds: [chunk.id],
      mechanic,
      challenge: `Solve a ${mechanic} challenge based on this knowledge chunk`,
      feedbackLoop:
        'challenge → action → feedback → reward → progress → next unlock',
    };
  });
}

export function runKnowledgeToGamePipeline(raw: string): {
  chunks: KnowledgeChunk[];
  playableUnits: PlayableUnit[];
} {
  const chunks = chunkKnowledge(raw);
  const playableUnits = buildPlayableUnits(chunks);
  return { chunks, playableUnits };
}
